import { createStore } from "vuex";

export default createStore({
    state: {
        fullUrl: '../assets/cleaner-image.png'
    },
    mutations: {},
    actions: {},
    modules: {},
});